import { componentHover } from "./hover";
import { initCarousel, destroyCarousel } from "./carousel";
import { initMimage, destroyMimage } from "./mimage";
import { initToggleSideBar } from "./sidebar";
import { selectToggle } from "./form";

function renderComponent(): void {
  initCarousel();
  initMimage();
  initToggleSideBar();
}

function destroyComponent(): void {
  destroyCarousel();
  destroyMimage();
}

// 事件委托类，统一调用一次
selectToggle();
componentHover();

export { componentHover, renderComponent, destroyComponent };
